export const orderItemColumns: string[] = [
  'ownerName',
  'membershipTypeName',
  'orderDate',
  'taxRate',
  'taxRateInclusive',
  'quantity',
  'productName',
  'sku',
  'isFee',
  'invoiceNumber',
  'orderStatus',
  'priceAmount',
  'discountAmount',
  'priceCurrency',
  'revenue',
  'margin',
  'profit',
];
